/**
 * @generated SignedSource<<6683755706542bf768eddb3732f89b50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CycleListInputQuery$variables = {
  archived?: boolean | null;
  name?: string | null;
};
export type CycleListInputQuery$data = {
  readonly viewer: {
    readonly cycles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly default: boolean;
          readonly endDate: string | null;
          readonly id: string;
          readonly name: string;
          readonly startDate: string | null;
        };
      } | null>;
    } | null;
  };
};
export type CycleListInputQuery = {
  response: CycleListInputQuery$data;
  variables: CycleListInputQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "archived"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "archived",
      "variableName": "archived"
    },
    {
      "kind": "Variable",
      "name": "name",
      "variableName": "name"
    }
  ],
  "concreteType": "CyclesConnection",
  "kind": "LinkedField",
  "name": "cycles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CyclesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Cycle",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "default",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CycleListInputQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CycleListInputQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "82033a3b737fef302d0221d9074bef2e",
    "id": null,
    "metadata": {},
    "name": "CycleListInputQuery",
    "operationKind": "query",
    "text": "query CycleListInputQuery(\n  $archived: Boolean\n  $name: String\n) {\n  viewer {\n    cycles(archived: $archived, name: $name) {\n      edges {\n        node {\n          id\n          name\n          default\n          startDate\n          endDate\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "279c598136a7b0a5f709f28e48d75183";

export default node;
